import { module } from 'modujs';
import Swiper from "swiper";

export default class extends module {
    constructor(m) {
        super(m);

        this.swiper = new Swiper(this.$( 'swiper' )[0] , { slidesPerView: 'auto' });

        this.swiper.on( 'sliderMove', e => {
            this.call( 'mouseMove', {clientX: e.touches.currentX, clientY: e.touches.currentY}, 'Cursor' )
        })
    }
    update(){
        this.swiper.update()
    }
    init() {}
    destroy(){}
}
